import {state as encState, type as encType} from './encounters';

export const status = {
	cancelled: 'Did not actualize',
	deal: 'Sale',
	done: 'Will be paid',
	new: 'New lead',
	open: 'Open [status]',
	cancelledVisit: 'Open [status]', // show lead as open if encounter is cancelledCalendarResource and lead state is cancelledVisit
};

export const state = encState;

export const type = encType;

export const marketingLeadsDeletedReasons = {
	outsideDeliveryArea: 'Outside of delivery area',
	wrongProduct: 'Wrong product',
	notReached: 'Not reached',
	customerService: 'Customer service',
	doubleBooked: 'Double-booked',
	test: 'Test',
	junkMail: 'Junk mail',
	other: 'Other',
};

export const marketingLeadStates = {
	cancelledCalendarResource: 'Cancelled calendar resource',
	needRecognisedNonUrgent: 'Need recognised non-urgent',
	wrongLocation: 'Wrong location',
	waitingForContact: 'Waiting for contact',
	notReached: 'Not reached',
	called: 'Called',
	textMessageSent: 'Text message sent',
	followupCall: 'Follow-up call agreed',
	callAttempt: 'Call attempt',
	transferredToSales: 'Transferred to sales',
	addToCalendarAsBonusTime: 'Add to team calendar as bonus time',
	salesProcessing: 'Processing at sales',
	visit: 'Visit booked',
	notReachedVisit: 'Visit did not actualize',
	offer: 'Offer',
	noOffer: 'Not offered',
	deal: 'Sale',
	cancelledDeal: 'Cancelled sale',
	installed: 'Installed',
	cancelled: 'Cancelled',
};

export const leadEventState = {
	cancelledCalendarResource: 'Cancelled calendar resource',
	needRecognisedNonUrgent: 'Need recognised (non-urgent)',
	wrongLocation: 'Wrong location',
	waitingForContact: 'Waiting for contact',
	notReached: 'Not reached',
	called: 'Called',
	textMessageSent: 'Text message sent',
	followupCall: 'Follow-up call',
	callAttempt: 'Call attempt',
	transferredToSales: 'Transferred to sales',
	addToCalendarAsBonusTime: 'Add to calendar as bonus time',
	salesProcessing: 'Sales processing',
	visit: 'Visit',
	notReachedVisit: 'Not reached (visit)',
	offer: 'Offer',
	noOffer: 'No offer',
	deal: 'Deal',
	cancelledDeal: 'Cancelled deal',
	installed: 'Installed',
	cancelled: 'Cancelled',
};
